import { 
  VOICE_TOGGLE_REQUEST, 
  VOICE_TOGGLE_SUCCESS, 
  VOICE_TOGGLE_FAILURE,
  VOICE_RESET
} from '../actions/voiceActions';

const initialState = {
  toggling: false,
  error: null,
  success: null
};

export default function voiceReducer(state = initialState, action) {
  switch (action.type) {
    case VOICE_TOGGLE_REQUEST:
      return { ...state, toggling: true, error: null, success: null };
    
    case VOICE_TOGGLE_SUCCESS:
      return {
        ...state,
        toggling: false,
        success: action.payload?.message || 'Voice mode updated successfully',
        error: null
      };
    
    case VOICE_TOGGLE_FAILURE:
      return {
        ...state,
        toggling: false,
        error: action.error,
        success: null
      };
    
    case VOICE_RESET:
      return initialState;
    
    default:
      return state;
  }
}
